module.exports = "\"<iframe class=\"map\"\r\n         [src]=\"mapEmbedUrl | safe\">\r\n</iframe>\"\r\n"